/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useMemo } from 'react';

import { DEFAULT_GROUP } from '../../constants/common';
import { grandTotalSorting } from '../../utils/chart/ChartManagementFeatures/sortChartFeatures';
import toEmptyConfig from '../EmptyConfig';
import calcFormula from '../../utils/chart/ChartFormula';
import ChartHolder from '../ChartHolder';
import { views } from '../../constants/event';
import { changeEventNames } from '../EventChart';
import { isDataEmpty } from '../Common';
import toPeriodLineConfig from './PeriodLineChart';
import toPeriodSunburstConfig from './PeriodSunburstChart';
import { toPeriodColumnConfig } from './PeriodColumnChart';
import { toPeriodChartData } from './PeriodChartDataConverter';

const getPeriodConfig = (view) => {
  switch (view) {
    case views.CHART:
      return toPeriodLineConfig;
    case views.COLUMN_CHART:
      return toPeriodColumnConfig;
    case views.PIE_CHART:
      return toPeriodSunburstConfig;
    case views.PERIOD_LINE_CHART:
      return toPeriodLineConfig;
    default:
      return toEmptyConfig;
  }
};

const findMatchingItems = (char, arr) => {
  const matchingItems = arr.filter((a) => {
    const tempString = a.id;
    const tempStringFirstChar = tempString.split('')[0];
    const isFirstCharSame = tempStringFirstChar === char;

    return tempString.length > 1 && !tempString.includes('Others') && isFirstCharSame;
  });

  return matchingItems;
};

const PeriodChart = ({
  result,
  executeTime,
  options,
  revenueType,
  timezone,
  group = DEFAULT_GROUP,
  height,
  setChart,
  fromDashboard,
  showSort,
}) => {
  const { enteredFormula } = options;

  const resultData = useMemo(
    () => changeEventNames(toPeriodChartData(result), revenueType),
    [executeTime]
  );

  const showCalcTotal = (chart) => grandTotalSorting(chart, options.columnChartSorting, group);

  const toConfig = useCallback(
    (data, single) => {
      const toChartConfig = isDataEmpty(data) ? toEmptyConfig : getPeriodConfig(options.view);

      const dataWithCumulative = data.map((dataItem) => {
        const currentResult = result.find(({ info }) => info.uniqueChar === dataItem.id);

        return {
          ...dataItem,
          showCumulative: !!currentResult?.info.query.aggregations.find(
            ({ type }) => type === 'TOTAL'
          ),
        };
      });

      return toChartConfig(
        dataWithCumulative,
        { ...options, timezone, group },
        showCalcTotal,
        fromDashboard,
        showSort,
        single
      );
    },
    [options.view, executeTime, options.singleChartMode, enteredFormula, options.columnChartSorting]
  );

  // для подсчета данных с формулой
  const dataWithFormula = useMemo(
    () => (!enteredFormula ? resultData : calcFormula(resultData, enteredFormula)),
    [enteredFormula, executeTime]
  );

  const groupAdditionalPeriod = (data) => {
    const resData = data
      .map((item, index, arr) => {
        const char = item.id;

        if (char.length === 1) {
          const rawArr = [item];
          const matchingItems = findMatchingItems(char, arr);

          rawArr.push(...matchingItems);
          const res = rawArr.filter((row) => {
            return !!row;
          });

          return res;
        }

        if (char.includes('Others')) {
          return item;
        }

        return null;
      })
      .filter((e) => !!e);

    return resData;
  };

  const totalData = useMemo(() => groupAdditionalPeriod(dataWithFormula), [dataWithFormula]);

  return (
    <ChartHolder
      setChart={setChart}
      data={totalData}
      toConfig={toConfig}
      single={options.singleChartMode}
      height={height}
    />
  );
};

export default PeriodChart;
